import React, { useState } from 'react'
import { gsColors } from '../../styles/Variables'
import { mq } from '../../helpers'
import SignInModal from './AuthModal'
import { isAuthenticated } from '../../services/Authenticator'
import { Text } from '../../styles/Components'
import styled from '@emotion/styled'

const SignInTextContainer = styled.div`
  margin: 66px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mq('max', '768px')} {
    margin: 32px 0 0;
  }

  p {
    ${mq('max', '768px')} {
      font-size: 14px !important;
    }

  }
  
  button {
    border: none;
    background-color: transparent;
    color: ${gsColors.sunsetOrange};
    font-family: Euclid;
    font-size: 18px;
    font-weight: 600;
    line-height: 138%;
    letter-spacing: 0.72px;
    
    ${mq('max', '768px')} {
      font-size: 14px !important;
    }

    &:hover {
      cursor: pointer;
    }
  }
`

// Inline variant: flows the leading copy and the "Sign in" link inside surrounding text (e.g. a
// subtitle line) instead of the standalone, margin-spaced block. Inherits the parent's font size
// and color so the copy blends into the sentence; only the link is recolored.
const SignInInline = styled.span`
  button {
    border: none;
    background-color: transparent;
    color: ${gsColors.sunsetOrange};
    font-family: Euclid;
    font-size: inherit;
    font-weight: 600;
    letter-spacing: 0.72px;
    padding: 0;

    &:hover {
      cursor: pointer;
    }
  }
`

/* SignInText
  * displays text to signin and redirects to login and takes you back to the page you were on.
  * Pass `inline` to render the copy and link inside a surrounding sentence rather than as a
  * standalone centered block.
  */
export default function SignInText({
  dispatch,
  showSignInLink = true,
  disabled = false,
  children,
  isDesktop,
  inline = false,
  onRequestOpen
}) {
  // state for controlling visibility of sign-in modal
  const [isSignInModalOpen, setSignInModalOpen] = useState(false)
  const closeSignInModal = () => {
    //dispatch authentication in case of a sign in for rerendering (for step 3 autofill)
    if (dispatch) {
      dispatch({ isAuthenticated: isAuthenticated() })
    }
    setSignInModalOpen(false)
  }

  // when a parent owns the modal (e.g. this link lives inside another modal it must close first),
  // hand off instead of opening the modal this component would render inside that soon-to-close subtree
  const openSignInModal = () => (onRequestOpen ? onRequestOpen() : setSignInModalOpen(true))

  if (isAuthenticated()) {
    return null
  }

  const link = showSignInLink && (
    <button
      disabled={disabled}
      onClick={openSignInModal}
    >
      Sign in
    </button>
  )
  const modal = (
    <SignInModal
      isOpen={isSignInModalOpen}
      close={closeSignInModal}
      isDesktop={isDesktop}
    />
  )

  if (inline) {
    return (
      <SignInInline>
        {children}
        {link}
        {modal}
      </SignInInline>
    )
  }

  return (
    <SignInTextContainer>
      <Text
        fontSize={18}
        lineHeight='138%'
        align='center'
        spacing={0.72}
      >
        {children}
      </Text>
      {link}
      {modal}
    </SignInTextContainer>
  )
}
